import { useState } from 'react';
import { useHistory } from "react-router";
import { ModalLoader } from '../../../../Components/Atoms/ModalLoader';
import { ScreenGreeting } from '../../../../Components/Molecules';
import { InvoiceListBuyers } from '../../../../Components/Molecules/Anticipation/InvoiceListBuyers';

export const InvoiceBuyers = () => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  return (
    <>
      <ModalLoader
        open={loading}
        text={"Carregando informações"}
      />
      <ScreenGreeting
        title={"Compradores"}
        subTitle={
          "Aqui você poderá acompanhar as informações dos seus compradores."
        }
        hasBackButton
        handleBack={() => history.goBack()}
      />
      <InvoiceListBuyers setLoading={setLoading} />
    </>
  );
};